import { useMemo } from 'react';
import { type VariantOption } from '../../../shared/useSelectedVariants';
import { type Columns } from '../EditableTable';
import { type BalloonTableRecord } from './shared';

const useColumns = (
    title: string,
    terms: number[],
    variants: VariantOption[],
    disabled: boolean,
    onUpdate: (record: BalloonTableRecord) => void
) =>
    useMemo<Columns<BalloonTableRecord>>(() => {
        const variantFilters = variants.map(variant => ({
            text: variant.name,
            value: variant.id,
        }));

        const results: Columns<BalloonTableRecord> = [
            {
                title,
                dataIndex: 'variantName',
                fixed: true,
                filters: variantFilters,
                onFilter: (value: string, record) => record.variantSuiteId === value,
                className: 'variant-column',
            },
        ];

        const termColumns = terms.map(term => ({
            title: `${term}`,
            dataIndex: `term${term}`,
            onCell: (record: BalloonTableRecord) => ({
                record,
                dataIndex: `term${term}`,
                isEditable: !disabled,
                onUpdate,
            }),
            className: 'terms-column',
        }));

        return [...results, ...termColumns];
    }, [variants, title, terms, disabled, onUpdate]);

export default useColumns;
